import { N40 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export const borderWidth = 1;
export const secondaryBorderColor = token('color.border', N40);
export const secondaryBorder = `${borderWidth}px solid ${secondaryBorderColor}`;
export const itemTransition = 'background-color 100ms linear';
